import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Sidebar from "../../img/sidebar.png";
import Ecommerce from "../../img/ecommerce.png";
import HOC from "../../img/hoc.png";
import insta from "../../img/insta.png";
import MusicApp from "../../img/musicapp.png";
import reddit from "../../img/reddd.png";
import amazon from "../../img/amapro.png";
import prod from "../../img/prod.png";
import supd from "../../img/supd.png";

import { themeContext } from "../../Context";

const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id="portfolio" data-aos="fade-up">
      {/* heading */}
      <span style={{ color: darkMode ? "white" : "" }}>Recent Projects</span>
      <span>Portfolio</span>
      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        preventClicks={false}
        preventClicksPropagation={false}
        className="portfolio-slider"
      >
        <SwiperSlide>
          <a
            class="swiper-slide"
            href="https://github.com/Ary65/Reddit-Clone"
            target="_blank"
          >
            <SwiperSlide>
              <img src={reddit} alt="" />
            </SwiperSlide>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://github.com/Ary65/Ecommerce" target="_blank">
            <SwiperSlide>
              <img src={amazon} alt="" />
            </SwiperSlide>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://github.com/Ary65/Producteve" target="_blank">
            <SwiperSlide>
              <img src={prod} alt="" />
            </SwiperSlide>
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://github.com/Ary65/Super-Docs" target="_blank">
            <SwiperSlide>
              <img src={supd} alt="" />
            </SwiperSlide>
          </a>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default Portfolio;
